var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { useState } from 'react';
import NxSearchDropdown from '../NxSearchDropdown';
import forwardRef from '../../../util/genericForwardRef';
import { statefulPropTypes as propTypes } from '../types';
function NxStatefulSearchDropdownRender(_a, ref) {
    var defaultSearchText = _a.defaultSearchText, onSelectProp = _a.onSelect, otherProps = __rest(_a, ["defaultSearchText", "onSelect"]);
    var _b = useState(defaultSearchText || ''), searchText = _b[0], setSearchText = _b[1];
    function onSelect(item, evt) {
        setSearchText('');
        onSelectProp(item, evt);
    }
    return React.createElement(NxSearchDropdown, __assign({}, __assign({ ref: ref, searchText: searchText, onSelect: onSelect }, otherProps), { onSearchTextChange: setSearchText }));
}
var NxStatefulSearchDropdown = Object.assign(forwardRef(NxStatefulSearchDropdownRender), { propTypes: propTypes });
export default NxStatefulSearchDropdown;
//# sourceMappingURL=NxStatefulSearchDropdown.js.map